import { useAppTheme } from "@hooks/useAppTheme";
import useMixedItemDist from "@hooks/useMixedItemDist";
import { Box, Loader, ScrollContainer, useDevice } from "@memorang/ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ProethicaQuickStudyDialog } from "../components/ProethicaQuickStudyDialog";
import { ProethicaCompletionCard } from "../components/Progress/ProethicaCompletionCard";
import { ProethicaScoresCard } from "../components/Progress/ProethicaScoresCard";
import { getProethicaModuleTags } from "../helpers/proethica-module-list";
import { buildProethicaProgress } from "../helpers/proethica-progress-data";
import { useProethicaModuleList } from "../hooks/useProethicaModuleList";

const PROGRESS_CONTENT_MAX_WIDTH = 1120;

const ProethicaProgressContainer = () => {
	const { t } = useTranslation();
	const theme = useAppTheme();
	const { isMobile } = useDevice();
	const { data: mixedItemDist, isLoading } = useMixedItemDist();
	const {
		getModuleListItemProps,
		resolveModuleItems,
		startModule,
		startingModuleId,
		preTestCompleted,
		postTestPassed,
	} = useProethicaModuleList();
	const [showQuickStudy, setShowQuickStudy] = useState(false);

	if (isLoading || !mixedItemDist) {
		return <Loader />;
	}

	const items = resolveModuleItems(getProethicaModuleTags(mixedItemDist.exams));
	const moduleProps = items.map((tag) => getModuleListItemProps(tag, t));
	const { completion, scoreRows } = buildProethicaProgress(
		moduleProps,
		mixedItemDist.tags ?? [],
		{ preTestCompleted, postTestPassed },
	);

	return (
		<ScrollContainer
			style={{ backgroundColor: theme.colors.background }}
			contentContainerStyle={{
				paddingTop: isMobile ? 16 : 32,
				paddingBottom: 48,
			}}
		>
			<Box
				width="100%"
				maxWidth={PROGRESS_CONTENT_MAX_WIDTH}
				alignSelf="center"
				paddingHorizontal={isMobile ? 16 : 32}
				flexDirection={isMobile ? "column" : "row"}
				alignItems="flex-start"
				style={{ gap: 16 }}
			>
				<Box flex={isMobile ? undefined : 1} width="100%" minWidth={0}>
					<ProethicaCompletionCard {...completion} />
				</Box>
				<Box flex={isMobile ? undefined : 1} width="100%" minWidth={0}>
					<ProethicaScoresCard
						scoreRows={scoreRows}
						remaining={completion.remaining}
						startingModuleId={startingModuleId}
						onModulePress={startModule}
						onContinue={() => setShowQuickStudy(true)}
					/>
				</Box>
			</Box>
			{showQuickStudy ? (
				<ProethicaQuickStudyDialog
					visible={showQuickStudy}
					handleClose={() => setShowQuickStudy(false)}
				/>
			) : null}
		</ScrollContainer>
	);
};

export default ProethicaProgressContainer;
